import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS , GREATER_THAN_ZERO} from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function MetodoPago(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
            
                    {
                        title: 'Fecha',
                        dataIndex: 'fechaPago',
                        key: 'fechaPago',
                        align: 'center',
                        width: '150px',
                        render:(value)=>moment(value).format("DD-MM-YYYY")
                    },
                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'nombreMetodoPago',
                        key: 'idMetodoPago',
                        width: '180px',
                      
                    },
        
                    {
                        title: 'Cuenta',
                        dataIndex: 'idCuenta',
                        key: 'idCuenta',
                        width: '220px',
                 
                    },
                    {
                        title: 'Nro Cuenta',
                        dataIndex: 'referencia',
                        key: 'referencia',
                        align: 'center',
                        width: '180px',
                     
                    },
                    {
                        title: 'Monto',
                        dataIndex: 'montoPago',
                        key: 'montoPago',
                        width: '180px',
                   
                    },
              
                ]}
            />
        </div>
    );
}